module.exports = function (app) {
    app.controller('pages.ndregistration.memberInformation', ['$scope', 'registration', '$window', '$filter', 'services', '$cookies', 'finder-logic2', 'session', 'coremetrics', 'brand',
        function ($scope, registration, $window, $filter, services, $cookies, finderLogic, session, coremetrics, brand) {
            var theBrand = brand.current.sharedBrandCode.toLowerCase();

            $scope.relationToHolderList=[
                {label: "Self", value: "SELF"},
                {label: "Spouse", value: "SPOUSE"},
                {label: "Custodial Parent/Guardian", value: "CUSTODIAL PARENT/GUARDIAN"},
                {label: "Domestic Partner", value: "DOMESTIC PARTNER"},
                {label: "Dependent / Other", value: "DEPENDENT/OTHER"}];
            $scope.phoneTypeList = [
                //{label: "Select type", value: "0"},
                {label: "Home", value: "HOME"},
                {label: "Work", value: "BUS"},
                {label: "Mobile", value: "CELL"}];

            $scope.cancelRegistration = function(){
                $window.location.replace('/member/home');
            };
            $scope.todayDate = new Date();
            $scope.minDate = new Date(1901,00,01);


            $scope.requiredCheck =false;

            $scope.checkPhoneNumber = function(phone){
                console.log("phonenumber data", phone);
                if(phone !== undefined && phone !== ''){$scope.requiredCheck = true;}
                else{$scope.requiredCheck =false;}
            };






        }
    ]);
    app.directive("limitTo", [function() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                var limit = parseInt(attrs.limitTo);
                angular.element(elem).on("keypress", function(e) {
                    if (this.value.length == limit) e.preventDefault();
                });
            }
        };
    }]);
    app.directive('iedates', function () {
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$validators.iedates = function (modelValue, viewValue) {

                    if (viewValue) {
                        if (!viewValue instanceof Date) {
                            return false;
                        } else if (!viewValue.match(/([12]\d{3})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])/)) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                };
            }
        };
    });
    app.directive('validAddress', function () {
        return {
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {

                var regex = /[!@#$%^*&()?{}:><+\\=_\[\]";]/;
                ctrl.$parsers.unshift(function (viewValue) {

                    if (regex.test(viewValue)) {
                        ctrl.$setValidity('validAddress', false);
                    } else {
                        ctrl.$setValidity('validAddress', true);
                    }
                    return viewValue;
                });
            }
        };
    });


};